import { Flex, Text } from '@mantine/core';
import { AddressRes } from '@dealstack/shared/lib/generated';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { SecurityPill } from '@dealstack/frontend/shared/components/SecurityPill/SecurityPill.tsx';
import { makeComplexDataTestId, TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { DetailsTileStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DetailsTile.styles.tsx';
import {
	formatAddress,
	getAddressTag,
	TAG_LABELS,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/AddressesCard/addresses.utils.ts';

interface Props {
	address: AddressRes;
}

export const AddressItem = ({ address }: Props) => {
	const tMipManage = useTranslationMipManage();
	const tag = getAddressTag(address);
	const formattedAddress = formatAddress(address);

	return (
		<DetailsTileStyles
			data-testid={makeComplexDataTestId(
				TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_ADDRESS,
				address.id
			)}
		>
			{formattedAddress ? (
				<Text fz={14} fw={600} c="dark.8">
					{formattedAddress}
				</Text>
			) : (
				<Text fz={14} c="dark.0">
					{tMipManage('investors.details.addresses_card.no_data', {
						defaultValue: 'No data available',
					})}
				</Text>
			)}

			{!!tag && (
				<Flex mt="0.25rem">
					<SecurityPill
						label={tMipManage(TAG_LABELS[tag].key, {
							defaultValue: TAG_LABELS[tag].defaultValue,
						})}
					/>
				</Flex>
			)}
		</DetailsTileStyles>
	);
};
